import(/* webpackMode: "eager" */ "/app/src/app/[locale]/gift-cards/page.tsx");
